(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sportszone-page-transition"] && !Shopify.designMode) return;
  try {
    const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const isCollectionToProduct = (destination) => {
  if (!destination) return false;

  try {
    const current = new URL(window.location.href);
    const next = new URL(destination, current.href);

    return (
      next.origin === current.origin &&
      current.pathname.includes('/collections/') &&
      next.pathname.includes('/products/')
    );
  } catch (error) {
    return false;
  }
};

const cancelOnInteraction = (viewTransition) => {
  if (!viewTransition) return;

  const cancel = () => viewTransition.skipTransition();

  document.addEventListener('pointerdown', cancel, { once: true });
  document.addEventListener('keydown', cancel, { once: true });

  viewTransition.finished.finally(() => {
    document.removeEventListener('pointerdown', cancel);
    document.removeEventListener('keydown', cancel);
  });
};

window.addEventListener('pageswap', (event) => {
  const viewTransition = event.viewTransition;
  if (!viewTransition) return;

  const destination = event.activation?.entry?.url;

  if (prefersReducedMotion() || !isCollectionToProduct(destination)) {
    viewTransition.skipTransition();
    return;
  }

  cancelOnInteraction(viewTransition);
});

window.addEventListener('pagereveal', (event) => {
  const viewTransition = event.viewTransition;
  if (!viewTransition) return;

  if (prefersReducedMotion()) {
    viewTransition.skipTransition();
    return;
  }

  cancelOnInteraction(viewTransition);
});
  } catch(e) { console.error(e); }
})();

})();
